import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@material-ui/core";
import { Panel } from "../../../panel";
import { addRegisteredLayout } from "../layoutDescriptions";
import { ThemeProvider } from "@material-ui/core/styles";
import { columnsSummaryHeaderTheme, useStyles, actionsTheme, reducedSummaryTheme } from "./styles";
const editableOptions = {
    title: false,
    elevation: true,
    square: true
};
const panels = {
    summaryHeader: {},
    summary: {
        editableOptions,
        defaultOptions: {
            literal: true
        }
    },
    main: { editableOptions },
    actions: {},
    appActions: {}
};
addRegisteredLayout({
    name: "ColumnSummary",
    displayName: "ColumnSummary",
    panels,
    reduceFormHeightForLaptops: true
});
export function ColumnSummary(props) {
    const classes = useStyles(props);
    const { header, panels, reduceFormHeightForLaptops } = props;
    const { summaryHeader, main, summary, actions, appActions } = panels;
    return (_jsxs(Grid, { container: true, spacing: 3, justifyContent: "center", children: [_jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, md: 4, container: true, alignItems: "stretch", children: header }), _jsx(Grid, { item: true, md: 4, container: true, alignItems: "stretch", children: summaryHeader && (_jsx(ThemeProvider, { theme: columnsSummaryHeaderTheme, children: _jsx(Panel, { ...summaryHeader, className: classes.summaryHeader }) })) }), _jsx(Grid, { item: true, md: 4, container: true, alignItems: "stretch", wrap: "nowrap", justifyContent: "flex-end", children: appActions && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { ...appActions, className: classes.actionsPanel, justifyContent: "flex-end" }) })) })] }) }), summary && (_jsx(Grid, { item: true, xs: 12, sm: 8, children: reduceFormHeightForLaptops ? (_jsx(ThemeProvider, { theme: reducedSummaryTheme, children: _jsx(Panel, { className: classes.mainSectionsReducedPadding, ...summary }) })) : (_jsx(Panel, { className: classes.mainSections, ...summary })) })), main && (_jsx(Grid, { item: true, xs: 12, sm: 8, children: _jsx(Panel, { className: reduceFormHeightForLaptops
                        ? classes.mainSectionsReducedPadding
                        : classes.mainSections, ...main }) })), _jsx(Grid, { item: true, xs: 12, sm: 8, children: actions && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { justifyContent: "flex-end", transparent: true, fullWidth: true, ...actions }) })) })] }));
}
//# sourceMappingURL=ColumnSummary.js.map